import React, { Component } from 'react';

class AboutMe extends Component {
	render() {
		return (
			<React.Fragment>
				<section className='section is-medium is-primary has-text-centered is-long'>
					<div className='container'>
						<div className='columns is-centered'>
							<div className='column is-three-fifths'>
								<h1 className='title is-spaced is-size-3-desktop is-size-4-mobile about-me__title'>
									Hello, I am Slava Nikolaevich.
								</h1>
								<div className='subtitle is-size-5-desktop'>
									<p className='about-me-content'>
										I'm 26 years old, and I started my web-development journey about
										eight years ago. Since then, I've developed plenty of projects
										and successfully passed many programming courses to be on the
										bleeding edge of Web technologies.
									</p>

									<div className='about-me-subcontent'>
										<h2 className='about-me-subcontent__title'>Work preferences:</h2>
										<p className='about-me-subcontent__text'>
											I prefer to work with the frontend part, even though I have
											experience working with the backend. I enjoy creating complex,
											catchy, and, most importantly, fast interfaces.
										</p>
									</div>

									<div className='about-me-subcontent'>
										<h2 className='about-me-subcontent__title'>
											Teamwork experience:
										</h2>
										<p className='about-me-subcontent__text'>
											Primarily, I’ve been working in teams from 2 to ~12 developers
											using git flow. I have broad experience in conducting code
											reviews. Also, I have some tech-lead experience: over a year of
											work as a frontend technical lead with six frontend developers
											in the team).
										</p>
									</div>

									<div className='about-me-subcontent'>
										<h2 className='about-me-subcontent__title'>Education:</h2>
										<p className='about-me-subcontent__text'>
											I graduated from Southern Federal University with honors in
											«Information Systems and Technologies».
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className='section skills has-text-centered'>
					<div className='container is-narrow'>
						<div className='box'>
							<div className='content'>
								<div className='columns is-centered'>
									<div className='column'>
										<figure className='image'>
											<img
												width='48'
												height='48'
												className='is-skill-icon'
												src='./media/icon-designer.svg'
												alt='front-end logo'
											/>
										</figure>
										<h1 className='title is-size-4 is-spaced'>Front-end</h1>
										<p className='list-title has-text-primary has-text-weight-normal'>
											What I prefer to work with:
										</p>
										<ul>
											<li>Responsive and cross-browser layout</li>
											<li>Styled-components, SCSS, Stylus</li>
											<li>Material UI, Ant Design, Bootstrap</li>
											<li>JavaScript (ES5-ES2021), TypeScript</li>
											<li>
												React.js, Redux (redux-toolkit + redux-sagas / thunk),
												GraphQL, SSR (Next.js)
											</li>
											<li>Vue.js + Vuex</li>
											<li>Desktop apps: Electron</li>
											<li>Unit testing: React testing library / Enzyme + Jest</li>
											<li>E2E testing: Cypress, Puppeteer </li>
											<li>Storybook</li>
											<hr />
											<li>Version control system: Git </li>
											<li>Bundler: Webpack</li>
											<li>Task runner: Gulp</li>
											<br />
											<hr />
											<li>
												Basic Figma, Sketch, Photoshop skills & Sense of beauty.
												<br /> I developed projects without design templates, and I
												made them stylish.
											</li>
										</ul>
									</div>
									<div className='column'>
										<figure className='image'>
											<img
												width='50'
												height='48'
												className='is-skill-icon'
												src='./media/icon-frontend.svg'
												alt='code logo'
											/>
										</figure>
										<h1 className='title is-size-4 is-spaced'>Back-end</h1>
										<p className='list-title has-text-primary has-text-weight-normal'>
											Languages:
										</p>
										<ul>
											<li>
												Mostly I worked with Node.js and its frameworks: <br />
												Nest.js, Express.js, Koa.js and pure Node.js
												<br />
												Monolith and micro-services architectures (GRPC and RabbitMQ
												communication)
											</li>
										</ul>
										<p className='list-title has-text-primary has-text-weight-normal'>
											DBMS:
										</p>
										<ul>
											<li>Mongo.db (ORM: Mongoose)</li>
											<li>PostgreSQL (ORM: Sequelize)</li>
											<li>Firebase, MySQL</li>
											<li>Redis, Memcached for caching</li>
										</ul>
										<p className='list-title has-text-primary has-text-weight-normal'>
											Other stuff:
										</p>
										<ul>
											<li>
												Cloud platforms:{' '}
												<i>
													AWS (EC2, S3, Elastic Load Balancer, AutoScaling group,
													EBS/EFS, RDS, ElastiCache, Route 53, Lambda, SES), Heroku
												</i>
											</li>
											<li>
												CI/CD: <i>GitlabCI, CircleCI, Jenkins</i>
											</li>
											<li>
												Containerization: <i>Docker</i>
											</li>
											<li>
												Logging & Monitoring: <i>Sentry</i>
											</li>
											<li>
												Payment services: <i>PayPal, Payture, Tinkoff</i>
											</li>
											<li>
												Web-scrapers development: Complex scrapers using a headless
												browser (Puppeteer) and usual URL-based ones
											</li>
											<li>
												CRM: <i>Bitrix 24</i>
											</li>
											<li>
												I had experience with <i>PHP (Laravel and WordPress)</i> in
												the past, but now I prefer to work with Node.js.
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		);
	}
}

export default AboutMe;
